import { render, staticRenderFns } from "./ModalVerViolacoes.vue?vue&type=template&id=0419c258"
import script from "./ModalVerViolacoes.vue?vue&type=script&lang=js"
export * from "./ModalVerViolacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports